.frame {
  position: relative;
}

.frame__card {
  height: 100%;
  border: 3px solid var(--color-primary-grey-900); /* ink */
  border-radius: 16px;
  box-shadow: 10px 10px 0 var(--color-primary-grey-900);
  overflow: hidden; /* clip the cover image to the rounded frame — no white mat shows */
  transform: rotate(2.5deg);
  transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.frame:hover .frame__card {
  transform: rotate(0deg);
}

.frame__image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover; /* fill the frame; the frame's aspect matches the photo so nothing is cropped */
  filter: saturate(1.12) contrast(1.04);
}
